import React, { Component } from "react";
import FetchImage from "./fetchImage";

class Footer extends Component {
  state = {};
  render() {
    return (
      <div
        id="footer2"
        class="d-flex align-items-center justify-content-center"
      >
        <div class="container">
          <div class="row">
            <div class="col-md-12 d-lg-flex align-items-lg-center justify-content-lg-center">
              <ul class="footer-nav-list d-flex align-items-center">
                <li>
                  <a href="/terms-and-conditions">Terms & Conditions</a>
                </li>
                <li>
                  <a href="/privacy-policy">Privacy Policy</a>
                </li>
                <li>
                  <a href="/accessibility">Accessibility</a>
                </li>
              </ul>
              <div class="copyright-box">
                <FetchImage image="copyright.svg" />
                {new Date().getFullYear()} <a>Salvex Group</a>, Inc.
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;
